export const encrptDecrptobj = (obj) => {
  // P0 hard-cut: client payload crypto removed. Pass plaintext objects through.
  return obj;
};
